import type { ReactNode, CSSProperties } from 'react'
import { usePrivacy } from '@/contexts/PrivacyContext'

interface PrivacyTextProps {
  children: ReactNode
  as?: 'span' | 'p' | 'div'
  className?: string
  style?: CSSProperties
  /**
   * Tooltip nativo — para texto que trunca (ex.: telefone no header do atendimento).
   * É DESCARTADO no modo privacidade: o texto na tela sai borrado, e um `title` com o
   * valor cru vazaria o dado inteiro no hover, anulando o modo.
   */
  title?: string
}

const privacyStyles: CSSProperties = {
  filter: 'blur(5px)',
  userSelect: 'none',
  pointerEvents: 'none',
}

export const PrivacyText = ({ children, as: Tag = 'span', className, style, title }: PrivacyTextProps) => {
  const { isPrivacyMode } = usePrivacy()

  return (
    <Tag
      className={className}
      style={isPrivacyMode ? { ...style, ...privacyStyles } : style}
      {...(title && !isPrivacyMode ? { title } : {})}
    >
      {children}
    </Tag>
  )
}
